import { render, staticRenderFns } from "./addInfos.vue?vue&type=template&id=3a974448&scoped=true&"
import script from "./addInfos.vue?vue&type=script&lang=js&"
export * from "./addInfos.vue?vue&type=script&lang=js&"
import style0 from "./addInfos.vue?vue&type=style&index=0&id=3a974448&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a974448",
  null
  
)

export default component.exports